import(/* webpackMode: "eager" */ "/home/devteam/haritweg/frontend/src/app/[locale]/forgot-password/page.js");
